<template>
<div class="min-h-screen flex flex-col py-6 bg-gray-50 sm:px-6 sm:py-12 lg:px-8">

  <div class="pt-12 sm:mx-auto sm:w-full sm:max-w-md lg:pt-16">
    <div class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">

      <div class="flex flex-col items-center">

        <XCircleIcon class="w-10 h-10 text-red-500" />

        <p class="mt-1 font-medium text-gray-600">Payment cancelled.</p>

        <TailwindButton
          @click="startOver"
          class="mt-7"
        >
          Start Over
        </TailwindButton>

      </div>
    </div>
  </div>

  <div class="mt-6 mx-auto px-4 w-full flex justify-between items-center sm:px-0 sm:max-w-md">
    <router-link :to="{ name: 'Home' }">
      <img src="../assets/TheTutorIndex-logo-horizontal.svg" alt="The Tutor Index" class="h-3" />
    </router-link>
    <div class="flex items-center">
      <span class="text-xs text-gray-500">Secured by</span>
      <img src="../assets/stripe-wordmark-slate.svg" alt="Stripe" class="h-5 opacity-60" />
    </div>
  </div>

</div>
</template>

<script>
import { XCircleIcon } from '@vue-hero-icons/outline'
import TailwindButton from './TailwindButton.vue'

export default {
  components: {
    XCircleIcon,
    TailwindButton
  },
  methods: {
    startOver() {
      return this.$router.push({
        name: 'PayTutor', 
        params: {
          id: this.$route.params.id,
          stub: this.$route.params.stub
        }
      })
    }
  },
  mounted() {
    
  }
}
</script>

<style>

</style>